import React from "react";
import {
  FaCreditCard,
  FaPiggyBank,
  FaWallet,
  FaHandHoldingUsd,
  FaIdCard,
  FaHome,
  FaFileInvoiceDollar,
  FaGlobe,
  FaChartPie,
} from "react-icons/fa";

function AppofCryptoBank() {
  return (
    <>
      <div className="pricing-style-one-area default-padding bg-gray">
        <div className="container">
          <div className="site-heading text-center">
            <h4 className="sub-title">What we do</h4>
            <h2 className="title split-text-right split-text-in-right">
              Applications of Crypto Banking: What Can Be Built?
            </h2>
            <p>
              Our team of Tezos blockchain experts is here to guide your journey
              in Web3 innovation. Partner with Xeer Technology to create
              scalable, secure, and community-driven applications on Tezos.
            </p>
          </div>
        </div>

        <div className="container">
          <div className="row">
            {/* LEFT */}
            <div className="col-xl-6">
              <ul className="pricing-types fade-up-anim">
                <li>
                  <div className="one">
                    <FaCreditCard size={35} />
                  </div>
                  <div className="info">
                    <h4>Crypto-Powered Payment Gateways</h4>
                    <p>
                      Enable seamless payments in crypto for online and in-store
                      purchases.
                    </p>
                  </div>
                </li>

                <li>
                  <div className="one">
                    <FaPiggyBank size={35} />
                  </div>
                  <div className="info">
                    <h4>Decentralized Savings Accounts</h4>
                    <p>
                      Provide interest-bearing savings accounts where users earn
                      passive income.
                    </p>
                  </div>
                </li>

                <li>
                  <div className="one">
                    <FaWallet size={35} />
                  </div>
                  <div className="info">
                    <h4>Multi-Currency Crypto Wallets with Fiat Integration</h4>
                    <p>
                      Support multiple cryptocurrencies with easy fiat
                      conversion.
                    </p>
                  </div>
                </li>

                <li>
                  <div className="one">
                    <FaHandHoldingUsd size={35} />
                  </div>
                  <div className="info">
                    <h4>P2P Lending and Borrowing Platforms</h4>
                    <p>
                      Enable decentralized lending and borrowing between users.
                    </p>
                  </div>
                </li>

                <li>
                  <div className="one">
                    <FaIdCard size={35} />
                  </div>
                  <div className="info">
                    <h4>Decentralized Identity Verification (KYC)</h4>
                    <p>
                      Blockchain-based identity verification for secure KYC
                      processes.
                    </p>
                  </div>
                </li>
              </ul>
            </div>

            {/* RIGHT */}
            <div className="col-xl-6">
              <ul className="pricing-types fade-up-anim">
                <li>
                  <div className="one">
                    <FaHome size={35} />
                  </div>
                  <div className="info">
                    <h4>Crypto-Backed Mortgage and Loan Services</h4>
                    <p>
                      Secure loans for real estate or personal needs using
                      crypto as collateral.
                    </p>
                  </div>
                </li>

                <li>
                  <div className="one">
                    <FaFileInvoiceDollar size={35} />
                  </div>
                  <div className="info">
                    <h4>Automated Tax and Compliance Tools</h4>
                    <p>
                      Simplify tax reporting and ensure compliance with
                      regulations.
                    </p>
                  </div>
                </li>

                <li>
                  <div className="one">
                    <FaGlobe size={35} />
                  </div>
                  <div className="info">
                    <h4>Cross-Border Remittance Platforms</h4>
                    <p>
                      Enable low-cost, instant international transfers using
                      blockchain.
                    </p>
                  </div>
                </li>

                <li>
                  <div className="one">
                    <FaChartPie size={35} />
                  </div>
                  <div className="info">
                    <h4>Tokenized Asset Portfolios</h4>
                    <p>
                      Access tokenized stocks, commodities, and real estate in
                      one platform.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AppofCryptoBank;
